/** @format */
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { OpenUniversityCart, OpenUniversitySettings } from 'common-typescript/types';
import { EMPTY, Observable } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { LocaleService } from 'sis-common';
import { OpenUniversityCartCustomerService, UniversityService } from 'sis-components';

@Component({
    selector: 'app-payment-processing',
    templateUrl: './payment-processing.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PaymentProcessingComponent implements OnInit {
    cart$: Observable<OpenUniversityCart>;
    openUniversitySettings$: Observable<OpenUniversitySettings>;

    constructor(
        private localeService: LocaleService,
        private openUniversityCartService: OpenUniversityCartCustomerService,
        private state: StateService,
        private universityService: UniversityService,
    ) {}

    ngOnInit(): void {
        this.cart$ = this.openUniversityCartService.getCurrentCart(true).pipe(catchError(() => EMPTY));
        this.openUniversitySettings$ = this.universityService.getCurrentUniversitySettings().pipe(
            catchError(() => EMPTY),
            map(settings => settings?.openUniversitySettings),
            filter(settings => !!settings?.customerServiceEmail || !!this.localeService.localize(settings?.customerServiceUrl)),
        );
    }

    backToSearch(): void {
        this.state.go('student.search.open-university');
    }
}
